/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

 var Shopify = Shopify || {};
 // ---------------------------------------------------------------------------
 // Money format handler
 // https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
 // ---------------------------------------------------------------------------
 Shopify.money_format = "${{amount}}";
 Shopify.formatMoney = function(cents, format) {
   if (typeof cents == 'string') { cents = cents.replace('.',''); }
   var value = '';
   var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
   var formatString = (format || this.money_format);
 
   function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
   }
 
   function formatWithDelimiters(number, precision, thousands, decimal) {
     precision = defaultOption(precision, 2);
     thousands = defaultOption(thousands, ',');
     decimal   = defaultOption(decimal, '.');
 
     if (isNaN(number) || number == null) { return 0; }
 
     number = (number/100.0).toFixed(precision);
 
     var parts   = number.split('.'),
         dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
         cents   = parts[1] ? (decimal + parts[1]) : '';
 
     return dollars + cents;
   }
 
   switch(formatString.match(placeholderRegex)[1]) {
     case 'amount':
       value = formatWithDelimiters(cents, 2);
       break;
     case 'amount_no_decimals':
       value = formatWithDelimiters(cents, 0);
       break;
     case 'amount_with_comma_separator':
       value = formatWithDelimiters(cents, 2, '.', ',');
       break;
     case 'amount_no_decimals_with_comma_separator':
       value = formatWithDelimiters(cents, 0, '.', ',');
       break;
   }
 
   return formatString.replace(placeholderRegex, value);
 };


(function () {

  var config = { attributes : true, attributeFilter : ['style'] };
  
  const shopTheLookBlocks = document.querySelectorAll('.shop-the-look__item');

  shopTheLookBlocks.forEach(function(block) {        
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutationRecord) {
        var blockVisibility = window.getComputedStyle(block).visibility;
        let blockId = block.classList[1].replace('shop-the-look__item-', '');
        if (blockVisibility == 'visible') {
          const infoBlocks = document.querySelectorAll('.shop-the-look__info');
          infoBlocks.forEach(function(infoBlock) {
            blockClass = infoBlock.classList[1].replace('info-block-', '');
            if (blockClass == blockId) {
              infoBlock.classList.remove('info-block--hidden');
            } else {
              infoBlock.classList.add('info-block--hidden');
            }
          });
        }
      });    
    });
    observer.observe(block, config);
  });
    
})();


( function(){

  window.addEventListener("scroll", e => {

    let headerBlock = document.querySelector('.header');
        
    if (document.documentElement.scrollTop >= 140 && headerBlock.classList.contains("big-logo")) {
      headerBlock.classList.add("scroll");
      headerBlock.classList.replace("big-logo", "small-logo");
    } 
    if (document.documentElement.scrollTop < 140 && headerBlock.classList.contains("small-logo"))  {
      headerBlock.classList.remove("scroll");
      headerBlock.classList.replace("small-logo", "big-logo");
    }
    
  });

})();



// Slider for featured products with custom type
(function(){ 

  let leftControl = document.querySelectorAll(".mySlides .prev");
  let rightControl = document.querySelectorAll(".mySlides .next");

  leftControl.forEach(function(control) {
    control.addEventListener("click", showSlides2.bind(this, -1))
  });

  rightControl.forEach(function(control) {
    control.addEventListener("click", showSlides2.bind(this, 1))
  });

  function showSlides2(direction) {
    let i;
    let slides = document.getElementsByClassName("mySlides");
    let slidesLength = slides.length;

    for (i = 0; i < slidesLength; i++) {
      if (!slides[i].classList.contains("hidden")) {
        slides[i].classList.add("hidden");
        slides[(((i + direction) % slidesLength) + slidesLength) % slidesLength].classList.remove("hidden");
        return;
      } 
    }    
  }
  
})();

/* -------------------------------------- START B2B COMPONENTS -------------------------------- */

/**
 * TODO: Move to separate file
 */

 class PriceService {
    static async getPrices(skus = []) {

        return new Promise((resolve) => {
            if(!window.b2b || !window.b2b.customerNumber) return resolve();

            const storageKey = `custom-prices-for-${window.b2b.customerNumber}`;

            setInterval(function () {
                const storageItem = window.localStorage.getItem(storageKey);

                if(storageItem) {
                    const allPrices = JSON.parse(storageItem)?.customer_prices || {};
                    const customerPrices = skus.map(sku => (allPrices[sku] || {}).price).filter(n => typeof n != "undefined" && n != null).sort();
                    
                    return resolve(customerPrices);
                }
            }(), 50);
        });
    }

    static removePricesIfLoggedOut() {
        if(!window.b2b || !window.b2b.customerNumber)
        {
            // iterate through all local storage items
            for (var i = 0; i < localStorage.length; i++) {
                // get key
                const key = localStorage.key(i);
                if (key.indexOf('custom-prices-for-') > -1) {
                    localStorage.removeItem(key);
                }
            }
        }
    }
}
PriceService.removePricesIfLoggedOut();

/**
 * TODO: Move to separate file
 */

const EshopGuideB2BPrice = class extends HTMLElement {
    static get observedAttributes() {
        return ['sku', 'uvp'];
    }

    connectedCallback() {
        this.renderPrice();
    }

    attributeChangedCallback() {
        this.renderPrice();
    }

    formatPrice(customerPrice, currency) {
        const money_format = currency ? window.b2bMoneyFormat.replace("€", currency): window.b2bMoneyFormat;
        return Shopify.formatMoney(customerPrice, money_format);
    }

    renderPrices(prices, currency) {
        const pricesSorted = (prices || []).sort((a, b) => (a-b));

        if(pricesSorted.length > 1 && pricesSorted[0] !== pricesSorted[pricesSorted.length-1]) {
            return `${this.formatPrice(pricesSorted[0], currency)} – ${this.formatPrice(pricesSorted[pricesSorted.length-1], currency)}`;
        } else {
            return this.formatPrice(pricesSorted[0], currency);
        }
    }

    renderUnit() {
        const skus = (this.getAttribute('sku') || '').split(',');

        if(window.egUnits && skus[0] && window.egUnits[skus[0]]) {
            return `<span class="eg__unit"> / ${window.egUnits[skus[0]].unit}</span>`;
        }

        return '';
    }

    async renderPrice() {
        const skus = (this.getAttribute('sku') || '').split(',');
        const customerPrices = await PriceService.getPrices(skus);
        const uvps = (this.getAttribute('uvp') || '').split(',');
        const uvpPrices = uvps.map(uvp => parseFloat(uvp));

        const vendor = this.getAttribute('vendor')?.toLowerCase();
        
        let priceString = '';

        // UVP
        if(uvpPrices.length > 0) {
          if (vendor.includes('burg wächter') || vendor.includes('burg-wächter')) {
            //BW - show UVP if customer is from DE/AT/CH
            if(typeof window.Geolizr == "undefined" || window.Geolizr?.geo?.data?.countryCode) {
              if(["DE", "AT", "CH"].includes(window.Geolizr?.geo?.data?.countryCode)) {
                priceString += `<span class="eg__uvp">${this.renderPrices(uvpPrices)} UVP ${this.renderUnit()}</span>`;
              }
            } else {
              document.addEventListener("geolizr.geo.data", (event) => {
                this.renderPrice();
              }, { once: true });
            }
          } else if(customerPrices && customerPrices.length > 0) {
            //BG - show UVP if customer is logged in and PriceService provided a price
            priceString += `<span class="eg__uvp">${this.renderPrices(uvpPrices)} UVP ${this.renderUnit()}</span>`;
          }
        }

        // Custom price (if logged in)
        if(window.b2b && window.b2b.customerNumber) {
            if(skus && customerPrices && customerPrices.length > 0) {
                priceString += `<span class="eg__price">${this.renderPrices(customerPrices, window.ek_currency)} EK ${this.renderUnit()}</span>`;
            }
        }

        // Tax note
        let taxNote;

        if((customerPrices && customerPrices.length > 0) || (uvpPrices && uvpPrices.length > 0)) {
          if(vendor.includes('burg wächter') || vendor.includes('burg-wächter')) {
            taxNote = window.b2b && window.b2b.customerNumber ? window.locales.includeTaxesCustomer : window.locales.includeTaxes;
          } else {
            taxNote = window.locales.taxNoteBurgGuard;
          }
        }

        if(taxNote && priceString) {
          const showUvpNote = ["DE", "AT", "CH"].includes(window.Geolizr?.geo?.data?.countryCode);
          priceString += `<div class="text--subdued text--xxsmall"><span class="product-meta__sku ${showUvpNote ? "" : "hide-uvp-note"}">${taxNote}</span></div>`;
        }

        this.innerHTML = priceString;
    }
}

window.customElements.define("eg-b2b-price", EshopGuideB2BPrice);

// Route all cart URLs to B2B Cart
document.addEventListener("click", (e) => {
  if (e.target.tagName === "A" && e.target.href.includes('/cart')) {
    e.preventDefault();
    e.stopPropagation();

    const path = (window.b2b && window.b2b.customerNumber) ? "/apps/b2b/cart" : "/account/login";
    window.location.href = path;
  }
});

/**
 * TODO: Move to separate file
 */
class CartService {
    async addItem(variant_id, quantity) {
        const payload = {
            variant_id,
            quantity,
            customer_number: window.b2b.customerNumber,
            shopify_customer_number: window.b2b.customerId
        };

        const response = await fetch('/apps/b2b/cart/add', {
            method: "POST",
            body: JSON.stringify(payload),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        });

        if(response.status === 200) {
            const responseJson = await response.json();

            document.documentElement.dispatchEvent(new CustomEvent("variant:added", {
              bubbles: true,
              detail: {
                variant: responseJson.hasOwnProperty("line_items") ? responseJson["line_items"][0] : responseJson
              }
            }));

            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                    cart: responseJson,
                    openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
                }
            }));

            document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: (response.status === 200 && (!responseJson.status || responseJson.status === 200)) ? "success" : "error",
                    error: responseJson["description"] || ""
                }
            }));

            await this.updateCart();
        }
    }

    async updateCart() {
        const response = await fetch("/apps/b2b/cart.json");
        const cartContent = await response.json();

        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
            cart: cartContent
            }
        }));
    }
}

const EshopGuideB2BAddToCart = class extends HTMLButtonElement {
    static get observedAttributes() {
        return ['variant', 'sku', 'unavailable'];
    }

    async submit() {
        if(this.storeLocator) {
          window.location.href = window.b2b?.settings?.store_locator_url;
          return;
        }

        if(this.contactLink) {
          window.location.href = this.contactLink;
          return;
        }

        const variantId = this.getAttribute('variant');
        const form = this.closest("form");
        const cartService = new CartService();
        let quantity = 1;

        if(form) {
            const formId = form.getAttribute('id');
            const quantityInput = document.querySelector(`[name="quantity"][form="${formId}"]`);

            if(formId && quantityInput) {
                quantity = quantityInput.value
            }
        }
        
        try {
            this.setAttribute("disabled", true);
            await cartService.addItem(variantId, quantity);
        } catch(err) {
            console.error(err);
        }
        
        this.removeAttribute("disabled");
    }

    connectedCallback() {
        this.render();
        this.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.submit();
        });
    }

    attributeChangedCallback(name) {
        this.render();
    }

    async render() {
        const variantId = this.getAttribute('variant');
        const sku = this.getAttribute('sku');
        const vendor = this.getAttribute('vendor') || window.productVendor;
        const unavailable = this.hasAttribute('unavailable');
        const quickBuyForm = this.hasAttribute('quickBuyForm') ? document.querySelector("#" + this.getAttribute('quickBuyForm')) : null;
        const productElement = this.closest('.js-product');

        // Reset
        this.removeAttribute('disabled');
        this.storeLocator = false;
        this.contactLink = null;

        // Variant Archieved
        const archived = (window.archivedVariants && window.archivedVariants.includes(parseInt(variantId)))
          || (this.hasAttribute("archivedVariants") && this.getAttribute("archivedVariants").includes(variantId));

        const price_block = productElement ? productElement.querySelector(".price-list") : null;
        const amount_block = productElement ? productElement.querySelector(".product-form__quantity") : null;

        if (archived) {
          this.innerText = window.locales.atc_archived;
          this.setAttribute('disabled', true);
          
          if(price_block) price_block.classList.add('hidden');
          if(amount_block) amount_block.classList.add('hidden');

          return;
        } else {
          if(price_block) price_block.classList.remove('hidden');
          if(amount_block) amount_block.classList.remove('hidden');
        }
        
        // Check if product has tag "Neu"
        if(this.getAttribute('isnew')) {
          this.innerText = window.locales.new;
          this.setAttribute('disabled', true);
          return;
        }

        // Not available / sold out
        if(!!unavailable || variantId === "false" || sku === "false") {
          this.setAttribute('disabled', true);
          if(this.hasAttribute('bestellartikel')) {
            this.innerText = window.locales.bestellartikel;
          } else {
            this.innerText = window.locales.soldOut;
          }
          return;
        }

        // get Prices (doesnt matter if they are shown but if they exist)
        let ek = false;
        const customerPrices = await PriceService.getPrices([sku]);
        if(sku && customerPrices && customerPrices.length > 0) {
          ek = true;
        }

        // Logged in
        if(window.b2b && window.b2b.customerId && window.b2b.vendor) {
          if(window.b2b.vendor == "BW") {
            if (vendor === "Burg Guard") {
              this.innerText = locales.atc_bg;
              this.contactLink = window.themeVariables.settings.defaultBgLink;
            } else {
              if (ek) {
                this.innerText = window.locales.addToCart;
                // show quickBuyDrawer if exists 
                if (quickBuyForm) {
                  this.classList.add("hidden");
                  if(amount_block) amount_block.classList.add('hidden');
                  quickBuyForm.classList.remove("hidden");
                }
              } else {
                this.innerText = locales.atc_bw;
                this.contactLink = window.themeVariables.settings.bwLinkInternal;
              }
            }
          }
          if(window.b2b.vendor == "BG") {
            //BG customers are allowed to buy BW products, if there is a EK price
            if (ek) {
              this.innerText = window.locales.addToCart;
              // show quickBuyDrawer if exists 
              if (quickBuyForm) {
                this.classList.add("hidden");
                if(amount_block) amount_block.classList.add('hidden');
                quickBuyForm.classList.remove("hidden");
              }
            } else {
              this.innerText = locales.atc_bg;
              this.contactLink = window.themeVariables.settings.bgLinkInternal;
            }
          }
        } else {
          // Not Logged in
          if (vendor === "Burg Guard") {
            this.innerText = locales.atc_bg;
            this.contactLink = window.themeVariables.settings.defaultBgLink;
          } else {
            this.innerText = window.locales.storeLocator
            this.storeLocator = true;
          } 
        }
    }
}

window.customElements.define("eg-b2b-add-to-cart", EshopGuideB2BAddToCart, {
    extends: 'button'
});

/* -------------------------------------- END B2B COMPONENTS -------------------------------- */

if(window.BoostOTP) {
    // Custom prices + A2C in Boost PFS app
    // Quickview (products with multiple variants)
    BoostOTP.QuickView.prototype.onChangeVariantOld = BoostOTP.QuickView.prototype.onChangeVariant;
    BoostOTP.QuickView.prototype.onChangeVariant = function() {
        BoostOTP.QuickView.prototype.onChangeVariantOld.call(this);
    
        const variant = this._getSelectedVariant();
        const $price = BoostPFS.jQ("#boost-pfs-quickview-current-custom-price");
        const $addToCart = BoostPFS.jQ("#boost-pfs-quickview-cart-custom-btn");

        $price.attr('sku', variant ? variant.sku : false);
        $price.attr('uvp', variant ? variant.price*100 : false);
        $addToCart.attr('sku', variant ? variant.sku : false);
        $addToCart.attr('variant', variant ? variant.id : false);
        variant.available ? $addToCart.removeAttr('unavailable') : $addToCart.attr('unavailable', true);
    }
    
    // A2C for products with only default variant
    BoostOTP.AddToCart.prototype.compileTemplateOriginal = BoostOTP.AddToCart.prototype.compileTemplate;
    BoostOTP.AddToCart.prototype.compileTemplate = function() {
        const data = this.parent.data;

        if(data.variants.length <= 1) {
            return `<div class="${Class.atcForm}">
                <button class="boost-pfs-addtocart-btn boost-pfs-addtocart-select-options" is="eg-b2b-add-to-cart" ${data.variants[0].available ? '' : 'unavailable'} variant="${data.variants[0].id}" sku="${data.variants[0].sku}"></button>
            </div>`;
        } else {
            return BoostOTP.AddToCart.prototype.compileTemplateOriginal.call(this);
        }
    }
}

document.addEventListener('variant:changed', function(event) {
    const variant = event.detail?.variant;
    const form = event.target;
    const formId = form.getAttribute("id");

    if(formId) {
        const priceElement = document.querySelector(`product-meta[form-id="${formId}"] eg-b2b-price`);
        const addToCartButton = document.querySelector(`product-payment-container[form-id="${formId}"] button[is="eg-b2b-add-to-cart"]`);
        const quantitySelector = document.querySelector(`input[name="quantity"][form="${formId}"]`);

        if(priceElement) {
            priceElement.setAttribute('sku', variant.sku);
            priceElement.setAttribute('uvp', variant.price);
        }

        if(addToCartButton) {
            addToCartButton.setAttribute('variant', variant.id);
            addToCartButton.setAttribute('sku', variant.sku);
            variant.available ? addToCartButton.removeAttribute('unavailable') : addToCartButton.setAttribute('available', true);
        }

        if(quantitySelector) {
            const unit = window.egUnits ? window.egUnits[variant.sku] : {} || {};
            let label = document.querySelector(".product-form__quantity-label");

            quantitySelector.setAttribute('min', unit.amount || 1);
            quantitySelector.setAttribute('step', unit.amount || 1);
            quantitySelector.quantity = unit.amount || 1;

            quantitySelector.parentElement.querySelector('.quantity-selector__unit').innerText = unit.unit || '';
            if (quantitySelector.quantity != 1) {
              label.innerHTML = window.locales.quantityLabelPackage;
            } else {
              label.innerHTML = window.locales.quantityLabelUnity;
            }
        }
    }
});
